import * as React from 'react';
import { Link } from 'react-router-dom';
import cn from '~modules/cn';
import ArrowLeft from '../../../assets/icons/v2design/navigation/arrow-left.svg';
import './hero.scss';

type Props = {
    title?: string;
    subtitle?: string;
    returnLink?: string;
    type?: 'light' | 'dark';
    direction?: 'vertical' | 'horizontal';
    children?: React.ReactNode;
};

const Hero: React.FC<Props> = (props) => {
    const { title, subtitle, returnLink, children, type = 'dark', direction = 'vertical' } = props;
    const classes = cn(`hero`, `hero--${type}`, `hero--${direction}`);
    return (
        <div className={classes}>
            <div className="hero-container">
                <div className="hero-title">
                    {returnLink && (
                        <div className="hero-return">
                            <Link to={returnLink}>
                                <ArrowLeft />
                            </Link>
                        </div>
                    )}
                    {title && <h1>{title}</h1>}
                    {subtitle && <p>{subtitle}</p>}
                </div>
                <div className="hero-children">{children}</div>
            </div>
        </div>
    );
};

export default Hero;
